<template>
  <b-modal ref="modal" class="text-left" @ok="saveAs" @cancel="portfolioName = ''">
    <div slot="modal-title">Save as</div>
    <b-form-group label="Portfolio Name:" label-for="portfolioName">
      <b-form-input id="portfolioName" v-model="portfolioName" class="calculation-settings-input"></b-form-input>
    </b-form-group>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      portfolioName: ""
    };
  },
  methods: {
    showModal() {
      this.$refs.modal.show();
    },
    saveAs() {
      this.$emit('saveAs', this.portfolioName)
      this.portfolioName = "";
    }
  }
};
</script>


